import Link from 'next/link';
import { getChain, type ChainId } from '@/lib/chains';

/**
 * Lens chip shown when a feed is filtered to one chain via `?chain=<id>`.
 * Identical to the inline chip proven on /market. `clearHref` = same path, ?chain stripped.
 */
export default function ChainLensChip({ chainId, clearHref }: { chainId: ChainId; clearHref: string }) {
  const chain = getChain(chainId);
  if (!chain) return null;
  return (
    <div className="mb-4 flex items-center gap-2 flex-wrap">
      <span className="font-mono text-xs uppercase tracking-wider text-neutral-500 dark:text-neutral-400">Lens</span>
      <span
        className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full font-mono text-xs font-bold text-white"
        style={{ backgroundColor: chain.color }}
      >
        {chain.label}
      </span>
      <Link
        href={clearHref}
        className="font-mono text-xs text-neutral-500 dark:text-neutral-400 hover:text-neutral-900 dark:hover:text-white underline-offset-2 hover:underline"
      >
        View all chains
      </Link>
    </div>
  );
}
